import Vue from 'vue';
import Component from 'vue-class-component';
import userIcon from 'common/icons/User2.svg';

@Component()
export default class NavbarMobileUserOutComponent extends Vue {
  userIcon = userIcon;
}
